import { render, staticRenderFns } from "./playVideos.vue?vue&type=template&id=44fa0a8c&scoped=true&"
import script from "./playVideos.vue?vue&type=script&lang=js&"
export * from "./playVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fa0a8c",
  null
  
)

export default component.exports